import { hc_boiler_id, hc_dhw_id, hc_id, hm_comfort_id, hm_economy_id, hm_off_id, hm_schedule_id, hm_summer_id, } from 'features/settings-master/model/default/ids';
import { SettingsMasterStep } from 'entities/settings-master/model/type';
export function getAdditionalUISettings(path) {
    // see heating_circuits_custom_icons
    const heating_circuits = {
        [hc_boiler_id]: path.includes(SettingsMasterStep.GasBoiler) ? 8 : 9,
        [hc_id]: 7,
    };
    if (path.includes(SettingsMasterStep.BoilerDHW)) {
        heating_circuits[hc_dhw_id] = 5;
    }
    // see custom_heating_modes_icons
    const heating_modes = {
        [hm_comfort_id]: 2,
        [hm_economy_id]: 4,
        [hm_schedule_id]: 9,
        [hm_off_id]: 6,
        [hm_summer_id]: 11,
    };
    return {
        icons: {
            heating_circuits,
            heating_modes,
        },
    };
}
